import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreamByRequestUid,
} from 'widgets/WidgetRegistry';
import LiquiditySummary from 'widgets/liquiditySummary/widget/LiquiditySummary';
import State from 'store/State';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { OrderColumns } from 'communication/types/order/Order';
import { LiquiditySummaryConfiguration } from 'widgets/liquiditySummary/store/configuration/LiquiditySummaryConfiguration';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { liquiditySummaryDescription } from 'widgets/liquiditySummary/description/liquiditySummaryDescription';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { buildLiquiditySummaryConfigSlice } from 'widgets/liquiditySummary/store/configuration/configSlice';
import { liquidityStreamConfig } from 'widgets/liquiditySummary/store/data/stream-config';
import { LiquidityStreamRequest } from 'widgets/liquiditySummary/api/LiquiditySummaryStreamRequest';

const { initialConfigState } = buildLiquiditySummaryConfigSlice();

export const liquiditySummaryWidgetStrategy: WidgetStrategyWithConfig<LiquiditySummaryConfiguration> &
    WidgetStrategyWithStreamByRequestUid<LiquidityStreamRequest> = {
    title: 'Liquidity Summary',
    supportedHosts: ['layout'],
    reactComponentType: LiquiditySummary,
    getRequiredOrderColumns,
    initialConfigState,
    categories: [WidgetCategory.SINGLE_STOCK],
    description: liquiditySummaryDescription,
    managedStreamConfig: liquidityStreamConfig,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.SingleSymbolQuantity,
};

function getRequiredOrderColumns(
    _state: State,
    _widgetId: string,
    _symbology: SymbologyValues
): OrderColumns {
    return ['rem'];
}
